module.exports = __webpack_public_path__ + "img/socialMediaTwitterNavy.8b7a56e8.svg";